var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ready-to-launch" }, [
    _c("h2", [_vm._v("Quick Review")]),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-8" }, [
        _c("div", { staticClass: "campaign-overview" }, [
          _c("h3", [_vm._v("Campaign Overview")]),
          _c("div", { staticClass: "campaign-overview-list" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-10 offset-md-1" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-6" }, [
                    _c("h4", [_vm._v("Campaign Name")]),
                    _c("h6", [
                      _vm._v(_vm._s(_vm.getCampaignDetail.campaign_name))
                    ]),
                    _c("h4", [_vm._v("Num of Activities")]),
                    _c("h6", [
                      _vm._v(_vm._s(_vm.getCampaignDetail.total_activity_count))
                    ]),
                    _c("h4", [_vm._v("Budget")]),
                    _c("h6", [
                      _vm._v(_vm._s(_vm.getCampaignDetail.campaign_budget))
                    ]),
                    _c("h4", [_vm._v("Incentive Type")]),
                    _c("h6", [
                      _vm._v(_vm._s(_vm.getCampaignDetail.incentive_type))
                    ]),
                    _c("h4", [
                      _vm._v("Start-Date - "),
                      _c("span", [
                        _vm._v(_vm._s(_vm.getCampaignDetail.start_date))
                      ])
                    ]),
                    _c("h4", [
                      _vm._v("End-Date - "),
                      _c("span", [
                        _vm._v(_vm._s(_vm.getCampaignDetail.end_date))
                      ])
                    ]),
                    _c("h4", [_vm._v("Unlock Code")]),
                    _c("h6", [
                      _vm._v(_vm._s(_vm.getCampaignDetail.unlock_code))
                    ])
                  ]),
                  _c("div", { staticClass: "col-md-6" }, [
                    _c("h4", [_vm._v("Geo-Location Type")]),
                    _c("h6", [
                      _vm._v(_vm._s(_vm.getCampaignDetail.geo_location_type))
                    ]),
                    _c("h4", [_vm._v("Single User Limit")]),
                    _c("h6", [
                      _vm._v(_vm._s(_vm.getCampaignDetail.single_user_limit))
                    ]),
                    _c("h4", [_vm._v("Incentives")]),
                    _c("h6", [_vm._v(_vm._s(_vm.getCampaignDetail.coupon))]),
                    _c("h4", [_vm._v("Package of Benefit")]),
                    _c("h6", [_vm._v(_vm._s(_vm.getCampaignDetail.package))]),
                    _c("h4", [_vm._v("Buy Me Activity")]),
                    _c("h6", [_vm._v("Not available for freemium")])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _vm.getCampaignDetail.status == "Awaiting Approval"
          ? _c("div", { staticClass: "action_button_box" }, [
              _c(
                "button",
                {
                  staticClass: "Reject_button",
                  on: {
                    click: function($event) {
                      return _vm.rejectCamp(_vm.getCampaignDetail.pickl_id)
                    }
                  }
                },
                [_vm._v("Reject")]
              ),
              _c(
                "button",
                {
                  staticClass: "Approve_button",
                  on: {
                    click: function($event) {
                      return _vm.approveCamp(_vm.getCampaignDetail.pickl_id)
                    }
                  }
                },
                [_vm._v("Approve")]
              )
            ])
          : _vm._e()
      ]),
      _c("div", { staticClass: "col-md-4" }, [
        _vm.getCampaignDetail.geo_location_type == "any-physical-location"
          ? _c("div", { staticClass: "preview" }, [
              _c("div", { staticClass: "brand_head" }, [
                _c("img", { attrs: { src: "/img/Arrow_2.png" } }),
                _vm._v("\n        " + _vm._s(_vm.getStoreDetail.brandName)),
                _c("br"),
                _vm._v(_vm._s(_vm.getStoreDetail.name) + "\n      ")
              ]),
              _c("h6"),
              _c("div", { staticClass: "store_brand" }, [
                _c("img", {
                  staticClass: "left_brand",
                  attrs: { src: _vm.getStoreDetail.img }
                }),
                _c("h6", [_vm._v("Do it at any location")]),
                _c("img", {
                  staticClass: "right_brand",
                  attrs: { src: _vm.getStoreDetail.brandImg }
                })
              ]),
              _c("div", { staticClass: "brand_intro" }, [
                _c("div", { staticClass: "brand_desc" }, [
                  _c("div", { staticClass: "brand_header" }, [
                    _c("img", { attrs: { src: _vm.getProductDetail.img } }),
                    _c("h6", { staticStyle: { "text-align": "left" } }, [
                      _vm._v(_vm._s(_vm.getProductDetail.name))
                    ]),
                    _c(
                      "p",
                      {
                        staticStyle: {
                          background: "transparent",
                          color: "#000"
                        }
                      },
                      [_vm._v(_vm._s(_vm.getProductDetail.description))]
                    )
                  ]),
                  _c(
                    "ul",
                    {
                      staticStyle: {
                        "max-height": "130px",
                        overflow: "hidden",
                        "padding-left": "0",
                        "margin-top": "15px"
                      }
                    },
                    _vm._l(_vm.getTasks, function(task) {
                      return _c("li", { key: task.name }, [
                        _vm._v(_vm._s(task.name))
                      ])
                    }),
                    0
                  ),
                  _c("img", {
                    staticClass: "start_pickl",
                    attrs: { src: "/img/start_pickl.png" }
                  })
                ])
              ]),
              _c("img", {
                staticClass: "task_bar",
                attrs: { src: "/img/phone_bottom.png" }
              })
            ])
          : _c("div", { staticClass: "preview cr_page" }, [
              _c("div", { staticClass: "brand_head" }, [
                _c("img", { attrs: { src: "/img/Arrow_2.png" } }),
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.getStoreDetail.brandName) +
                    "\n      "
                )
              ]),
              _c("div", { staticClass: "media_name" }, [
                _vm._v("\n        " + _vm._s(_vm.media.title) + "\n      ")
              ]),
              _c("div", { staticClass: "your_video" }, [
                _c("span", [
                  _c("iframe", {
                    attrs: {
                      width: "100%",
                      height: "120px",
                      src: "https://www.youtube.com/embed/" + _vm.videoId,
                      title: "YouTube video player",
                      frameborder: "0",
                      allow:
                        "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
                      referrerpolicy: "strict-origin-when-cross-origin",
                      allowfullscreen: ""
                    }
                  })
                ])
              ]),
              _c(
                "div",
                {
                  staticClass: "brand_intro",
                  staticStyle: { top: "266px !important" }
                },
                [
                  _c("div", { staticClass: "brand_desc" }, [
                    _c("div", { staticClass: "brand_header" }, [
                      _c("img", { attrs: { src: _vm.brandInfo.logo } }),
                      _c("h6", [_vm._v(_vm._s(_vm.brandInfo.name))]),
                      _c("p", [_vm._v("Introduction")])
                    ]),
                    _c(
                      "p",
                      {
                        staticStyle: {
                          "font-size": "13px",
                          padding: "12px",
                          "text-align": "left"
                        }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.media.description) +
                            "\n          "
                        )
                      ]
                    )
                  ])
                ]
              ),
              _c("img", {
                staticClass: "task_bar",
                attrs: { src: "/img/phone_bottom.png" }
              })
            ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }